import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import useSeo, { CANONICAL_BASE } from "@/lib/useSeo";
import { toast } from "sonner";

export default function Contact() {
  const [page, setPage] = useState(null);
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "", phone: "", order_number: "" });
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);
  useSeo({ title: "Contact — ONUSA", description: "Neem contact op met ONUSA.", canonical: CANONICAL_BASE + "/contact" });
  useEffect(() => { api.get("/content/contact").then(({ data }) => setPage(data)).catch(() => {}); }, []);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/contact", { ...form, phone: form.phone || null, order_number: form.order_number || null });
      toast.success(data.message);
      setSent(true);
    } catch (err) { toast.error(formatApiError(err.response?.data?.detail)); } finally { setBusy(false); }
  };
  const inp = "w-full bg-white border border-[#E8E1D8] px-3 py-2.5 text-sm outline-none focus:border-[#1D1D1B]";

  return (
    <div className="onusa-container py-16 md:py-24 max-w-2xl" data-testid="contact-page">
      <p className="label-x">ONUSA</p>
      <h1 className="heading-x text-3xl md:text-5xl mt-2 mb-6">CONTACT</h1>
      <p className="text-[#77736D] leading-relaxed mb-8">{page?.body || "Heb je een vraag over je bestelling, een product of onze PROTOCOL-wereld? Stuur ons een bericht en we reageren zo snel mogelijk."}</p>

      {sent ? (
        <div className="border border-[#E8E1D8] bg-white p-8 text-center" data-testid="contact-sent">
          <p className="heading-x text-xl">BEDANKT</p>
          <p className="text-[#77736D] mt-3">We hebben je bericht ontvangen en reageren zo snel mogelijk via e-mail.</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="contact-form">
          <div className="grid sm:grid-cols-2 gap-4">
            <input required placeholder="Naam" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={inp} data-testid="contact-name" />
            <input required type="email" placeholder="E-mail" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={inp} data-testid="contact-email" />
            <input placeholder="Telefoon (optioneel)" value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className={inp} data-testid="contact-phone" />
            <input placeholder="Bestelnummer (optioneel)" value={form.order_number} onChange={(e) => setForm({ ...form, order_number: e.target.value })} className={inp} data-testid="contact-order" />
          </div>
          <input required placeholder="Onderwerp" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} className={inp} data-testid="contact-subject" />
          <textarea required rows={5} placeholder="Je bericht" value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className={inp} data-testid="contact-message" />
          <button disabled={busy} className="btn-x" data-testid="contact-submit">{busy ? "VERZENDEN…" : "VERSTUUR BERICHT"}</button>
        </form>
      )}
      <div className="mt-10 rule-x pt-8"><p className="label-x">E-MAIL</p><a href="mailto:info@onusa.nl" className="text-lg">info@onusa.nl</a></div>
    </div>
  );
}
